import { useMemo } from 'react';
export const useGetRuleIdToLabelMap = () => {
  const siteLevelruleIdToLabelKeyMap = useMemo(() => ({
    DOM_ORDER: 'accessibility-wizard.rules-list.dom-order.title',
    SITE_LANGUAGE: 'accessibility-wizard.rules-list.site-language.title',
    SKIP_TO_MAIN_CONTENT: 'accessibility-wizard.rules-list.skip-to-main-content.title',
    VISUAL_INDICATORS: 'accessibility-wizard.rules-list.visual-indicators.title'
  }), []);
  const pageLevelruleIdToLabelKeyMap = useMemo(() => ({
    COLOR_CONTRAST: 'accessibility-wizard.rules-list.color-contrast.title',
    HEADING_STRUCTURE: 'accessibility-wizard.rules-list.heading-definition.title',
    INACCESSIBLE_COMPONENTS: 'accessibility-wizard.rules-list.inaccessible-components.title',
    INACCESSIBLE_LAYOUT: 'accessibility-wizard.rules-list.inaccessible-layout.title',
    MEDIA_ALTERNATIVES: 'accessibility-wizard.rules-list.media-alternatives.title',
    PAGE_AUTO_DOM_ORDER: 'accessibility-wizard.rules-list.page-auto-dom-order.title',
    STATIC_ALT_TEXT: 'accessibility-wizard.rules-list.static-alt-text.title',
    VALID_PAGE_TITLE: 'accessibility-wizard.rules-list.valid-title-tag.title'
  }), []);
  return {
    pageLevelruleIdToLabelKeyMap,
    siteLevelruleIdToLabelKeyMap
  };
};
//# sourceMappingURL=use-get-ruleId-to-label-map.js.map